<div class="flex flex-column px-4">
  <span class="my-3">{{ modalContent.header | transloco }}</span>

  <span>{{ modalContent.subHeader | transloco }}</span>

  @if (screen === screens.DASHBOARD) {
    <div class="flex do-not-show">
      <p-checkbox
        class="mr-2"
        [binary]="true"
        [(ngModel)]="isDoNotShowAgain"></p-checkbox>
      <span>{{ 'COMMON.DO_NOT_SHOW_THIS_POPUP_AGAIN' | transloco }}</span>
    </div>
  }
</div>

<div>
  <p-divider></p-divider>
</div>

<div class="flex justify-content-end px-4 pb-4">
  <p-button
    styleClass="p-button-outlined mr-3"
    [disabled]="isConfirmInProgress"
    [label]="modalContent.secondaryAction | transloco"
    (onClick)="onBackClicked()" />
  <p-button
    styleClass="p-button"
    [disabled]="isConfirmInProgress"
    [label]="modalContent.primaryAction | transloco"
    (onClick)="onConfirmClicked()" />
</div>
